module.exports = __webpack_public_path__ + "static/media/schoolingImage.cd41498a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/schoolingImage.jpg
// module id = 816
// module chunks = 12